import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const bullets = ['Te gustan los tatuajes japoneses', 'Querés entender los símbolos reales', 'Buscás inspiración para futuros diseños', 'Te interesa la cultura japonesa', 'Disfrutás los libros visuales de colección', 'Querés aprender más sobre el irezumi', 'Te atraen los samuráis y la mitología japonesa', 'Buscás referencias visuales auténticas'];
export function IdentificationSection() {
  return <section className="w-full py-20 md:py-28 px-4" data-id="element-196">
      <div className="max-w-4xl mx-auto" data-id="element-197">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-198">
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] mb-6 uppercase" data-id="element-199">
            ¿TE FASCINA EL{' '}
            <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-200">
              TATUAJE JAPONÉS
            </span>
            ?
          </h2>
          <p className="text-ink-soft text-base md:text-lg max-w-2xl mx-auto leading-relaxed" data-id="element-201">
            Muchas personas conocen un dragón. Una koi. Una máscara. Pero muy
            pocas conocen la historia, el simbolismo y la tradición que existe
            detrás de cada composición.
          </p>
          <p className="text-rose font-serif-italic text-xl md:text-2xl mt-5" data-id="element-202">
            No es falta de interés. Es falta de una fuente completa.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-3 mb-12" data-id="element-203">
          {bullets.map((b, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -8
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05,
          duration: 0.4
        }} className="flex items-start gap-3 bg-bg-warm border border-line rounded-2xl p-4 md:p-5 shadow-sm" data-id="element-204">
              <span className="flex-shrink-0 w-7 h-7 rounded-full bg-rose/10 flex items-center justify-center mt-0.5" data-id="element-205">
                <span className="text-rose text-sm" data-id="element-206">🌸</span>
              </span>
              <span className="text-ink text-sm md:text-base" data-id="element-207">{b}</span>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-bg-warm border border-line rounded-3xl p-8 md:p-12 text-center shadow-sm" data-id="element-208">
          <p className="font-serif-italic text-2xl md:text-3xl leading-relaxed text-ink" data-id="element-209">
            "¿Y SI ESTE FUERA EL PRIMER PASO PARA ENTRAR AL UNIVERSO DEL{' '}
            <span className="text-rose font-semibold not-italic uppercase" data-id="element-210">
              IREZUMI
            </span>
            ?"
          </p>
        </motion.div>
      </div>
    </section>;
}